import { Box, Typography } from '@mui/material'

import IconBadge from './IconBadge'

const SalesRequestBenefit = ({ icon, title, description }) => (
  <Box display="flex" gap={1.5} alignItems="flex-start">
    <IconBadge icon={icon} />
    <Box>
      <Typography variant="subtitle2" fontWeight="bold">
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {description}
      </Typography>
    </Box>
  </Box>
)

export default SalesRequestBenefit
